<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        <div v-if="flowShow">合同申请</div>
        <div v-if="typeShow">会议预订</div>
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="labourParticulars" v-if="typeShow">
        <h4 class="labourParticulars-title labourParticulars-title-active">教室预定流程</h4>
        <p>1. 预订流程 </p>
        <span class="labourParticulars-title-content-active">将会议或活动的时间、人数、用途、使用人、设备支持等其他要求告知教务管理部教辅主管王浩宽（wanghaokuan）进行预订。</span>
        <p>2. 特别说明 </p>
        <span class="labourParticulars-title-content-active">教室闲置情况随排课情况、会议安排而变动，无法完全保证，请需要的老师员工们尽早预订。</span>
    </div>
    <div class="labourParticulars" v-if="flowShow">
        <h4 class="labourParticulars-title labourParticulars-title-active">适用范围与合同规范</h4>
        <p> 1. 适用范围</p>
        <span class="spanClass labourParticulars-title-content-active">签订租赁、采购、广告、异业合作等合同。</span>
        <p>2. 合同规范</p>
        <span class="spanClass labourParticulars-title-content-active">签订的合同文本中，前后主体应保持一致，金额、交付日期及付款方式明晰，同时需含有反舞弊条款（如制式合同文本无法添加反舞弊条款，则增加合同附件条款（详见附录五））。</span>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return {
            typeShow: false,
            flowShow: false,
            agreementShow: false
        }
    },
    methods:{
        fn(){
            var code = this.$route.params.code
            if(code == 13){
                this.typeShow = true
            } else if(code == 99){
                this.flowShow = true
            } else if(code == 79){
                this.agreementShow = true
            }
        },
        getOnPage1(){
            var code = this.$route.params.code
            console.log(code)
            if(code == 99){
                this.$router.push({name:"Administrative10"})
            } else if(code == 13){
                this.$router.push({name:"Administrative"})
            }
        },
        getOnPage(){
            var code = this.$route.params.code
            if(code == 99){
                this.$router.push({name: 'Search', params:{code:"y"}})
            }else if(code == 13){
                this.$router.push({name: 'Search', params:{code:"1111"}})
            }
        },
    },
    mounted(){
        this.fn()
    }
};
</script>

<style>
.box-labourParticulars {
  width: 100%;
  height: 100%;
  background: rgba(244, 244, 244, 1);
}
.upClass,
.searchClass {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}
.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}
.upClass {
  width: 12px;
  float: left;
  left: 10px;
}

.searchClass {
  width: 19px;
  float: right;
  right: 10px;
}

.labourParticulars {
  width: 90%;
  height: 83%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
  border-radius: 11px;
  padding-top: 5%;
}
.labourParticulars .labourParticulars-title {
  text-align: center;
  font-weight: 600;
}
.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}
.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
  display: block;
  line-height: 35px;
  margin-left: 16px;
  margin-right: 16px;
  color: #888787;
  font-size: 15px;
  text-indent:30px;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrative3.vue